<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img @click="closeModal()" src="@/assets/icons/close.png" alt="close-modal-img">
    </div>
    <div class="modal-title">
      remove {{modalData.title}} ?
    </div>
    <div class="btn-wrapper">
      <div @click="remove" class="btn">
        remove
      </div>
      <div @click="closeModal()" class="btn">
        cancel
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
import { api } from '@/api'
export default {
  name: 'removeCodebook',
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  methods: {
    remove () {
      let params = {
        id: this.modalData.id
      }
      api[this.modalData.deleteApi](params).then(res => {
        console.log(res)
        this.modalData.refresh()
        this.$toast.success('Success', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Error', {
          duration: 8000
        })
      }).finally(() => {
        this.closeModal()
      })
    },
    closeModal () {
      eventBus.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
